<div
  #routineDayFormModal
  class="fade modal-xl modal"
  data-bs-backdrop="static"
  data-bs-keyboard="false"
  id="routineDayFormModal"
  tabindex="-1"
  aria-labelledby="routineDayFormModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header w-100 d-flex justify-content-between">
        <h1 class="modal-title fs-5" *ngIf="!watching">
          Creación de día de la rutina
        </h1>
        <h1 class="modal-title fs-5" *ngIf="watching">
          Visualización de día de la rutina
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          (click)="cleanAllForms()"
        ></button>
      </div>
      <div class="modal-body">
        <ul class="nav nav-underline mb-3" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button
              class="nav-link active"
              data-bs-toggle="tab"
              #generalTab
              type="button"
              role="tab"
              aria-controls="home-tab-pane"
              aria-selected="true"
              (click)="selectTab('routineNameDescription')"
            >
              General
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button
              #exerciseTab
              class="nav-link"
              data-bs-toggle="tab"
              type="button"
              role="tab"
              aria-selected="false"
              *ngIf="editingRoutineDay"
              (click)="selectTab('routineExercises')"
            >
              Ejercicios
            </button>
          </li>
        </ul>

        <form
          [formGroup]="routineDayForm"
          (ngSubmit)="manageNameDescription()"
          *ngIf="tabSelected == 'routineNameDescription'"
        >
          <div class="form-floating mb-3">
            <input
              class="form-control"
              type="text"
              [ngClass]="{ 'is-invalid': name.invalid && name.touched }"
              placeholder="Nombre"
              formControlName="name"
            />

            <label for="">Nombre</label>

            <div *ngIf="name.invalid && name.touched" class="text-danger">
              Ingrese un nombre válido.
            </div>
          </div>

          <div class="form-floating mb-3">
            <select
              class="form-select"
              id="dayOfWeek"
              formControlName="dayOfWeek"
              [ngClass]="{
                'is-invalid': dayOfWeek.invalid && dayOfWeek.touched
              }"
            >
              <option value="" selected disabled>Selecciona un día</option>
              <option value="MONDAY">Lunes</option>
              <option value="TUESDAY">Martes</option>
              <option value="WEDNESDAY">Miércoles</option>
              <option value="THURSDAY">Jueves</option>
              <option value="FRIDAY">Viernes</option>
              <option value="SATURDAY">Sábado</option>
              <option value="SUNDAY">Domingo</option>
            </select>
            <label for="dayOfWeek">Día de la semana</label>
            <div
              *ngIf="dayOfWeek.invalid && dayOfWeek.touched"
              class="text-danger"
            >
              Selecciona un día válido.
            </div>
          </div>

          <div class="input-group">
            <div class="form-floating">
              <textarea
                class="form-control"
                type="text"
                id="description"
                [ngClass]="{
                  'is-invalid': description.invalid && description.touched
                }"
                placeholder="Descripción"
                formControlName="description"
                style="height: 100px"
              ></textarea>

              <label for="description">Descripción (opcional)</label>
            </div>
          </div>
          <div
            *ngIf="description.invalid && description.touched"
            class="text-danger"
          >
            Ingrese una descripción valida.
          </div>

          <button
            [disabled]="routineDayForm.invalid"
            class="col-12 mt-1 d-grid btn-custom"
            *ngIf="!watching"
          >
            <span *ngIf="editingRoutineDay">Editar</span>
            <span *ngIf="!editingRoutineDay">Crear</span>
          </button>
        </form>

        <div
          *ngIf="tabSelected == 'routineExercises'"
          class="d-flex flex-lg-row flex-column row"
        >
          <div class="col-lg-6 col-12">
            <form
              [formGroup]="exerciseForm"
              *ngIf="tabSelected == 'routineExercises'"
            >
              <h4 class="mt-3" *ngIf="tabSelected == 'routineExercises'">
                Selector de ejercicios
              </h4>
              <span>Grupo muscular</span>
              <select
                class="form-select form-select mb-1"
                aria-label="Small select example"
                (change)="onSelectMuscleGroup($event)"
                formControlName="muscleGroup"
                (click)="enableExercises()"
              >
                <option selected>Selecciona grupo muscular</option>
                <option
                  [value]="mg.id"
                  (click)="enableExercises()"
                  *ngFor="let mg of muscleGroups"
                >
                  {{ mg.name }}
                </option>
              </select>

              <label for="exampleDataList" class="form-label">Ejercicio</label>
              <input
                class="form-control mb-1"
                list="datalistOptions"
                id="exampleDataList"
                formControlName="exercise"
                placeholder="Escribe un ejercicio..."
                [disabled]="true"
                autocomplete="off"
              />
              <datalist id="datalistOptions" style="width: 100%">
                <option
                  *ngFor="let exercise of exercises"
                  [value]="exercise.name"
                ></option>
              </datalist>

              <div class="input-group mb-3">
                <div class="form-floating">
                  <textarea
                    class="form-control"
                    type="text"
                    [ngClass]="{
                      'is-invalid':
                        exerciseSeries.invalid && exerciseSeries.touched
                    }"
                    placeholder="Series"
                    formControlName="exerciseSeries"
                    style="height: 100px"
                  ></textarea>

                  <label for="">Series</label>
                </div>
              </div>
              <div
                *ngIf="exerciseSeries.invalid && exerciseSeries.touched"
                class="text-danger"
              >
                Ingrese un formato de series válido.
              </div>

              <div class="input-group">
                <div class="form-floating mb-3">
                  <textarea
                    class="form-control"
                    type="text"
                    placeholder="Series"
                    formControlName="weights"
                    style="height: 100px"
                  ></textarea>

                  <label for="">Pesos (opcional)</label>
                </div>
              </div>

              <div class="input-group">
                <div class="form-floating mb-3">
                  <textarea
                    class="form-control"
                    type="text"
                    placeholder="Series"
                    formControlName="trainerComment"
                    style="height: 100px"
                  ></textarea>

                  <label for="">Comentario para alumno (opcional)</label>
                </div>
              </div>

              <button
                [disabled]="routineDayForm.invalid || isLoading"
                class="col-12 d-grid btn-custom"
                (click)="manageExercise()"
                *ngIf="!watching"
              >
                <span
                  *ngIf="isLoading"
                  class="loader border-t-4 border-blue-500 rounded-full w-6 h-6 animate-spin"
                >
                  <span
                    class="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  ></span>
                </span>
                <span *ngIf="!isLoading">
                  <span *ngIf="editingExercise">Editar Ejercicio</span>
                  <span *ngIf="!editingExercise"> Agregar Ejercicio</span>
                </span>
              </button>
            </form>
            <button
              [disabled]="routineDayForm.invalid"
              style="height: 25px"
              class="col-12 mt-1 d-flex align-items-center justify-content-center btn btn-outline-secondary"
              *ngIf="
                !editingExercise &&
                exercisesByExerciseGroup.length > 0 &&
                !watching
              "
              (click)="
                createExercise(
                  exercisesByExerciseGroup[
                    exercisesByExerciseGroup.length - 1
                  ][0].exerciseGroup,
                  false
                )
              "
            >
              <span> Agregar en superserie con último</span>
            </button>
          </div>
          <div class="col-lg-6 col-12">
            <h2 class="mt-2">Ejercicios</h2>
            <div
              class="row d-flex justify-content-center exercise-group mx-2 rounded mb-2 mx-lg-4 p-2 pb-4"
              *ngFor="let eg of exercisesByExerciseGroup"
            >
              <span class="p-2" *ngIf="eg.length == 2">Superserie</span>
              <span class="p-2" *ngIf="eg.length == 3">Triserie</span>
              <span class="p-2" *ngIf="eg.length > 3">Serie Gigante</span>

              <div class="row">
                <div
                  class="col-10 d-flex justify-content-center flex-column align-items-center"
                >
                  <div class="card col-12 m-lg-2 mb-2" *ngFor="let e of eg">
                    <div
                      class="card-body d-flex flex-row justify-content-between"
                      (click)="exerciseMoreInfo(e)"
                    >
                      <div>
                        <span class="mb-2"
                          >{{ e.internalExerciseGroupOrder + 1 }}.</span
                        >
                        <h5 class="card-title">{{ e.exercise.name }}</h5>
                        <p class="card-text">{{ e.summary }}</p>
                        <p class="card-text">{{ e.trainerComment }}</p>
                      </div>
                      <div
                        class="d-flex flex-column justify-content-center align-items-center"
                      >
                        <i
                          class="bi bi-pencil-square mx-lg-3 mx-2"
                          style="cursor: pointer"
                          (click)="selectExerciseToEdit(e)"
                          *ngIf="!watching"
                        ></i>
                        <i
                          class="bi bi-trash"
                          style="color: red; cursor: pointer"
                          (click)="deleteRoutineModelExercise(e.id, eg)"
                          *ngIf="!watching"
                        ></i>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="d-flex flex-column align-items-center justify-content-around col-1"
                >
                  <i
                    class="bi bi-caret-up-fill"
                    style="cursor: pointer"
                    (click)="
                      switchExerciseGroupOrder(
                        eg[0],
                        eg[0].exerciseGroup,
                        'down'
                      )
                    "
                    *ngIf="!watching"
                  ></i>
                  <i
                    class="bi bi-caret-down-fill"
                    style="cursor: pointer"
                    (click)="
                      switchExerciseGroupOrder(eg[0], eg[0].exerciseGroup, 'up')
                    "
                    *ngIf="!watching"
                  ></i>
                </div>
              </div>
              <button
                class="btn btn-outline-secondary w-100 py-0 fs-3"
                (click)="createExercise(eg[0].exerciseGroup, false)"
                *ngIf="!editingExercise && !watching"
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
